import { Children, ReactNode, isValidElement } from 'react'
import { useResizeDetector } from 'react-resize-detector'
import { Allotment } from 'allotment'

import Box from '@mui/material/Box'

type PaneProps = {
  children: ReactNode
}

function Pane({ children }: PaneProps) {
  return <>{children}</>
}

type DiagnosticAllotmentProps = {
  children: ReactNode
  defaultSizes?: number[]
  minSizeRatio?: number
}

export function DiagnosticAllotment({ children, defaultSizes = [60, 40], minSizeRatio = 3 }: DiagnosticAllotmentProps) {
  const { width: containerWidth = 0, ref: containerRef } = useResizeDetector()

  const minSize = containerWidth / minSizeRatio

  const panes: ReactNode[] = []

  Children.forEach(children, (child, index) => {
    if (isValidElement(child) && child.type === Pane) {
      panes.push(
        <Allotment.Pane key={index} minSize={minSize}>
          {child.props.children}
        </Allotment.Pane>
      )
    }
  })

  return (
    <Box ref={containerRef} sx={{ flex: 1, height: '100%' }}>
      <Allotment defaultSizes={defaultSizes}>{panes}</Allotment>
    </Box>
  )
}

DiagnosticAllotment.Pane = Pane
